import React from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import Title from "../../common/components/view/ViewTitle";
import View from "../../common/components/view/View";
import ViewHeader from "../../common/components/view/ViewHeader";
import { useSelectJobQuery } from "../graphql";
import BackButton from "../../common/components/view/BackButton";
import Form from "../../common/components/form/Form";
import { useForm, OnSubmit } from "react-hook-form";
import FormSubmit from "../../common/components/form/FormSubmit";
import ViewContent from "../../common/components/view/ViewContent";
import FormField from "../../common/components/form/FormField";
import FormFieldLabel from "../../common/components/form/FormFieldLabel";
import FormFieldInput from "../../common/components/form/FormFieldInput";
import TypeaheadInput from "../../common/components/input/TypeaheadInput";
import FormFieldErrors from "../../common/components/form/FormFieldErrors";
import Button from "../../common/components/input/Button";
import HorizontalSpacer from "../../common/components/layout/HorizontalSpacer";

interface FormData {
  job: string;
}

interface ViewParams {
  activity: string;
}

const SelectJobView: React.FC = () => {
  const history = useHistory();
  const match = useRouteMatch();
  const formContext = useForm<FormData>();
  const { data, loading } = useSelectJobQuery();

  const onSubmit: OnSubmit<FormData> = data => {
    history.push(`${match.url}/${data.job}`);
  };

  const onBack = () => {
    history.push("/");
  };

  return (
    <View>
      <ViewHeader>
        <BackButton />
        <Title>Group Selection</Title>
      </ViewHeader>
      <ViewContent loading={loading}>
        {data && (
          <Form context={formContext} onSubmit={onSubmit}>
            <FormField
              name="job"
              rules={{
                required: "The job field is required."
              }}
            >
              <FormFieldLabel>Select Job</FormFieldLabel>
              <FormFieldInput>
                <TypeaheadInput
                  sort="desc"
                  items={data.jobCards.map(jobCard => ({
                    value: jobCard.number,
                    title: `${jobCard.number} ${jobCard.description}`
                  }))}
                />
              </FormFieldInput>
              <FormFieldErrors />
            </FormField>
            <div className="flex-grow" />
            <div className="flex">
              <Button className="w-full" onClick={onBack}>
                Back
              </Button>
              <HorizontalSpacer />
              <FormSubmit>Continue</FormSubmit>
            </div>
          </Form>
        )}
      </ViewContent>
    </View>
  );
};

export default SelectJobView;
